import React from 'react'
import PropTypes from 'prop-types'
import { Form, Button, FormGroup } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormFooter from '../../../../common/forms/FormFooter'
import FormItem from '../../../../common/forms/FormItem'
import { isRequired } from '../../../../../utils/validators'
import TextInput from '../../../../common/forms/input/TextInput'
import { GENDERS } from '../../../../../config/constants'
import Select from '../../../../common/forms/select/Select'
import { tzNormalizeDate } from '../../../../../utils/date'
import DatePicker from '../../../../common/forms/input/DatePicker'

const EditCustomerUpdateHistoryForm = ({ handleSubmit, onCancel }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label='Nombre' required>
        <Field
          name='firstName'
          component={TextInput}
          placeholder="Nombre del Pasajero"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label='Apellido' required>
        <Field
          name='lastName'
          component={TextInput}
          placeholder="Apellido del Pasajero"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label='Genero' required>
        <Field
          name="gender"
          component={Select}
          options={GENDERS}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Fecha de Nacimiento" required>
        <Field
          name="dateOfBirth"
          props={{
            max: tzNormalizeDate(),
          }}
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label='Telefono' required>
        <Field
          name="mobilePhone"
          component={TextInput}
          placeholder="Telefono del Pasajero"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label='Correo Electrónico' required>
        <Field
          name="email"
          component={TextInput}
          placeholder="Correo Electrónico"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter saveButtonColor="primary" saveButtonIcon={null}>
      <Button color="secondary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
)

EditCustomerUpdateHistoryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default reduxForm({
  form: 'EditCustomerUpdateHistoryForm',
})(EditCustomerUpdateHistoryForm)
